<template>
  <div>
    <v-layout row wrap>
      <v-flex>
        <SelectCuentaBancaria
          :model="itemActivo.Id_CuentaBancaria"
          :rules="rules"
          :readonly="readonly"
          @seleccionarItem="seleccionarCuentaBancaria"
        />
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex>
        <v-select
          label="Chequera*"
          v-model="iModel"
          :items="items"
          item-value="Id_Chequera"
          item-text="Nombre"
          :rules="rules"
          :readonly="readonly"
          :loading="loading"
        >
          <template v-slot:no-data
            >No hay datos para mostrar</template
          >
          <template v-slot:progress>
            <v-progress-circular
              color="blue"
              indeterminate
            ></v-progress-circular>
          </template>
        </v-select>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
import SelectCuentaBancaria from "@/components/Banco/SelectCuentaBancaria";
export default {
  name: "SelectChequera",
  props: {
    model: Number,
    id_CuentaBancaria: Number,
    rules: {},
    readonly: Boolean
  },
  components: {
    SelectCuentaBancaria
  },
  data() {
    return {
      rutaApi: "Chequera/",
      itemVacio: {
        Id_CuentaBancaria: 0,
        NombreCuentaBancaria: "",
        Id_Chequera: 0,
        Nombre: "",
        NumeroActual: 0
      },
      itemActivo: {},
      items: [],
      loading: false
    };
  },
  watch: {
    id_CuentaBancaria(valor) {
      if (valor) {
        this.itemActivo.Id_CuentaBancaria = valor;
        this.listarItems();
      }
    }
  },
  computed: {
    iModel: {
      get() {
        return this.model;
      },
      set(valor) {
        if (valor != undefined) {
          let ind = this.items.findIndex(x => x.Id_Chequera == valor);
          this.itemActivo.Id_Chequera = this.items[ind].Id_Chequera;
          this.itemActivo.Nombre = this.items[ind].Nombre;
          this.itemActivo.NumeroActual = this.items[ind].NumeroActual;
          this.$emit("seleccionarItem", this.itemActivo);
        }
      }
    }
  },
  created() {
    eventBus.$on("setearFocoSelectChequera", this.setearFoco);
    eventBus.$on("inicializarSelectChequera", this.inicializar);
    this.inicializar();
  },
  beforeDestroy() {
    eventBus.$off("setearFocoSelectChequera", this.setearFoco);
    eventBus.$off("inicializarSelectChequera", this.inicializar);
  },
  methods: {
    inicializar() {
      this.itemActivo = Object.assign({}, this.itemVacio);
      this.items = [];
    },
    seleccionarCuentaBancaria(item) {
      if (item) {
        this.itemActivo.Id_CuentaBancaria = item.Id_CuentaBancaria;
        this.itemActivo.NombreCuentaBancaria = item.Nombre;
        this.listarItems();
      }
    },
    listarItems() {
      this.loading = true;
      HttpHelper.get(this.rutaApi + "ListarSelect", {
        id_CuentaBancaria: this.itemActivo.Id_CuentaBancaria
      })
        .then(response => {
          this.items = response.data;
          this.loading = false;
        })
        .catch(error => {
          return Promise.reject(error);
        });
    },
    setearFoco() {
      setTimeout(() => {
        eventBus.$emit("setearFocoSelectCuentaBancaria");
      }, 100);
    }
  }
};
</script>
